import { SvgIcon } from '@mui/material';

export function ListViewIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M9.3077 18.7499V17.25H20.5V18.7499H9.3077ZM9.3077 12.7499V11.25H20.5V12.7499H9.3077ZM9.3077 6.74995V5.25H20.5V6.74995H9.3077ZM5.16345 19.6634C4.706 19.6634 4.3144 19.5005 3.98865 19.1748C3.66288 18.849 3.5 18.4574 3.5 18C3.5 17.5425 3.66288 17.1509 3.98865 16.8252C4.3144 16.4994 4.706 16.3365 5.16345 16.3365C5.6209 16.3365 6.0125 16.4994 6.33825 16.8252C6.664 17.1509 6.82687 17.5425 6.82687 18C6.82687 18.4574 6.664 18.849 6.33825 19.1748C6.0125 19.5005 5.6209 19.6634 5.16345 19.6634ZM5.16345 13.6634C4.706 13.6634 4.3144 13.5005 3.98865 13.1748C3.66288 12.849 3.5 12.4574 3.5 12C3.5 11.5425 3.66288 11.1509 3.98865 10.8252C4.3144 10.4994 4.706 10.3365 5.16345 10.3365C5.6209 10.3365 6.0125 10.4994 6.33825 10.8252C6.664 11.1509 6.82687 11.5425 6.82687 12C6.82687 12.4574 6.664 12.849 6.33825 13.1748C6.0125 13.5005 5.6209 13.6634 5.16345 13.6634ZM5.16345 7.6634C4.706 7.6634 4.3144 7.50052 3.98865 7.17477C3.66288 6.84902 3.5 6.45742 3.5 5.99997C3.5 5.54252 3.66288 5.15092 3.98865 4.82517C4.3144 4.49942 4.706 4.33655 5.16345 4.33655C5.6209 4.33655 6.0125 4.49942 6.33825 4.82517C6.664 5.15092 6.82687 5.54252 6.82687 5.99997C6.82687 6.45742 6.664 6.84902 6.33825 7.17477C6.0125 7.50052 5.6209 7.6634 5.16345 7.6634Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
